export var DEFAULT_CONSTRAINTS = {
    audio: false,
    video: { facingMode: "environment" },
};
export var DEFAULT_TIME_BETWEEN_DECODING_ATTEMPTS = 300;
